// extracted by mini-css-extract-plugin
export default {"info_center":"roomassign_info_center__Q72AM","info":"roomassign_info__fXMO-"};